import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Avatar from 'components/common/Avatar';
import Flex from 'components/common/Flex';
import { weUserImage2 } from 'data/weraise-data/donar-data';
import React, { useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import ReactSelect from 'react-select';
import {
  AttachmentsItems,
  ListItemData,
  SoftBadeItem
} from './ProjectCommonComponents';

const ProjectCompletionReport = () => {
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [projectStatus, setProjectStatus] = React.useState([]);

  const handleSubmit = event => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };

  const citiesData = ['Mogadishu', 'Nairobi', 'Ruiru', 'Karachi', 'New york'];
  const attachments = [
    { id: '1', title: 'winter.jpg', type: 'image/jpeg', size: 121212 },
    { id: '2', title: 'winter.png', type: 'image/jpeg', size: 1212 },
    { id: '3', title: 'title.zip', type: 'application/zip', size: 21212 },
    { id: '4', title: 'doc.pdf', type: 'application/pdf', size: 121432121 },
    { id: '5', title: 'data.cvs', type: 'text/csv', size: 121212 },
    { id: '6', title: 'winter 1.png', type: 'image/jpeg', size: 1212 },
    { id: '7', title: 'title.zip', type: 'application/zip', size: 21212 },
    { id: '8', title: 'tutorial.mp4', type: 'video/mp4', size: 12122243121 }
  ];

  const projectStatusOptions = [
    { value: '1', label: 'Complete' },
    { value: '2', label: 'Pending' },
    { value: '3', label: 'In Progress' },
    { value: '4', label: 'Backlog' },
    { value: '5', label: 'ToDo' }
  ];

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <Card className="mb-3">
        <Card.Header className="bg-100">
          <Card.Title className="fw-medium mb-0">
            <FontAwesomeIcon icon={'paperclip'} className="me-2" />
            AL007 | Al-Walidayn Orphanage Centre for boys
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <Flex
            justifyContent={'between'}
            className="flex-column flex-md-row align-items-start align-items-md-center"
          >
            <Flex alignItems={'center'}>
              <Avatar src={weUserImage2} size="2xl" />
              <div className="ms-2">
                <p className="mb-0">Ali Mohamed</p>
                <p className="mb-0 text-500">Project Manager</p>
              </div>
            </Flex>
            <p className="mb-0 text-1000 mt-3 mt-md-0 w-100 w-md-auto text-end">
              01 March, 2020 | 8:40 AM <i>(1 Day ago)</i>
            </p>
          </Flex>
          <hr />
          <div className="font-base">
            <ListItemData title="Creation Date" value="01/01/2023" />
            <ListItemData title="Completion Date" value="01/01/2024" />
            <ListItemData title="Number of Beneficiaries" value="895" />
            <ListItemData
              title="City(ies)"
              content={
                <div className="w-75">
                  <SoftBadeItem data={citiesData} />
                </div>
              }
            />
            <ListItemData title="Total Cost" value="$ 20,000" />
            <ListItemData title="Administration cost" value="$ 1,000" />
            <ListItemData
              title="Project Feedback"
              value="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis aliquet ligula vitae facilisis vulputaterutrum cursus lacinia. Praesent consectetur semper nunc, sit amet rutrum dui commodo afor Short video placeholder for use in website templates and live mockups."
              direction="column"
            />
            <ListItemData
              title="Vedio"
              content={
                <a
                  target="_blank"
                  href="https://www.youtube.com/watch?v=NpEaa2P7qZI"
                  rel="noreferrer"
                >
                  https://www.youtube.com/watch?v=NpEaa2P7qZI
                </a>
              }
              direction="column"
            />
          </div>
          <AttachmentsItems
            attachments={attachments}
            deleteItem={id => console.log(id)}
            downloadAllClick={() => console.log('Download all')}
          />
        </Card.Body>
      </Card>
      <Card className="mb-3">
        <Card.Header>
          <Card.Title className="fw-medium mb-0">Project Status</Card.Title>
        </Card.Header>
        <Card.Body className="pt-0">
          <Row className="g-3">
            <Form.Group as={Col} md={12}>
              <Form.Label>Status</Form.Label>
              <ReactSelect
                closeMenuOnSelect={true}
                options={projectStatusOptions}
                placeholder="Select"
                classNamePrefix="react-select"
                value={projectStatus}
                onChange={value => setProjectStatus(value)}
                menuPosition="fixed"
              />
            </Form.Group>
            <Form.Group as={Col} md={12} controlId="Comments">
              <Form.Label>Comments</Form.Label>
              <Form.Control as="textarea" rows={4} required />
            </Form.Group>
          </Row>
        </Card.Body>
      </Card>
      <Card>
        <Card.Body>
          <Flex
            justifyContent="between"
            alignItems="center"
            className="flex-column flex-md-row"
          >
            <p className="mb-0 fs-2 mb-2 mb-md-0 fw-medium">Request Status</p>
            <Button className="w-215px" onClick={() => navigate(-1)}>
              Submit
            </Button>
          </Flex>
        </Card.Body>
      </Card>
    </Form>
  );
};

export default ProjectCompletionReport;
